<template>
	<section class="nl" :class="'nl--' + align">
		<div class="nl__inner">
			<h2 v-if="heading" class="nl__h">{{ heading }}</h2>
			<p v-if="text" class="nl__p">{{ text }}</p>
			<div class="nl__form" v-html="embedTag"></div>
		</div>
	</section>
</template>

<script>
/**
 * NewsletterSignupBlock.vue
 * ─────────────────────────
 * A styled band around the MediaOS newsletter sign-up widget
 * (`<mediaos-newsletter-subscribe>`). Heading and text use the site
 * tokens; theme, padding and background come from the wrapper traits.
 */
import { buildEmbedTag } from '@/websites/cms/blocks/shared/blockUtils.js';

export default {
	name: 'NewsletterSignupBlock',

	props: {
		heading: { type: String, default: 'Get the newsletter' },
		text: { type: String, default: '' },
		newsletterIds: { type: String, default: '' },
		skipName: { type: [Boolean, String], default: true },
		showSocialSignIn: { type: [Boolean, String], default: false },
		align: { type: String, default: 'center' }
	},

	computed: {
		embedTag: function () {
			var attrs = {};
			if (this.newsletterIds) attrs['newsletter-ids'] = String(this.newsletterIds);
			if (this.skipName === true || this.skipName === 'true') attrs['skip-name'] = 'true';
			if (!(this.showSocialSignIn === true || this.showSocialSignIn === 'true')) attrs['sso-enabled'] = 'false';
			return buildEmbedTag('mediaos-newsletter-subscribe', attrs);
		}
	}
};
</script>

<style scoped>
.nl { width: 100%; max-width: 100%; color: inherit; }
.nl__inner { max-width: 640px; margin: 0 auto; display: flex; flex-direction: column; gap: .75rem; }
.nl--left .nl__inner { margin: 0; text-align: left; }
.nl--center .nl__inner { text-align: center; }
.nl__h { margin: 0; font-family: var(--site-h2-font, var(--site-heading-font)); font-size: var(--site-h2-size, 2em); font-weight: var(--site-h2-weight, 700); line-height: 1.2; color: inherit; }
.nl__p { margin: 0; opacity: .85; font-size: 1.05em; }
.nl__form { margin-top: .5rem; }
.nl__form :deep(mediaos-newsletter-subscribe) { display: block; }
</style>
